<template>
  <div class="search-field-input">
    <af-h2 noMarginTop>
      <label
        :for="name"
        class="search-field-input__label">
      {{ label }}
      </label>
    </af-h2>
    <input
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      class="search-field-input__input"
      type="text"
      @blur="handleBlur"
      @focus="handleFocus"
      @input="handleChange" />
    <slot></slot>
  </div>
</template>

<script>
import AfH2 from '@/components/AfH2'

export default {
  name: 'SearchFieldInput',
  components: {
    AfH2
  },

  props: {
    label: {
      required: true,
      type: String
    },
    name: {
      required: true,
      type: String
    },
    placeholder: String,
    value: {
      required: true,
      type: String
    }
  },

  methods: {
    handleBlur() {
      this.$emit('onBlur')
    },
    handleFocus() {
      this.$emit('onFocus')
    },
    handleChange(event) {
      this.$emit('update:value', event.target.value)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-field-input {
  margin-bottom: var(--spacing-medium);
  position: relative;
  -ms-grid-column: 1;
  -ms-grid-row: 1;

  @media (--bp-desktop) {
    margin-bottom: 0;
  }

  @media (--ie11) and (--bp-desktop) {
    margin-right: 20px;
  }
}

.search-field-input__label {
  align-items: center;
  display: flex;
}

.search-field-input__input {
  background: var(--color-white);
  border: 1px solid var(--color-iron);
  border-radius: 4px;
  box-sizing: border-box;
  color: #000;
  font-size: 16px;
  font-family: 'Open sans', sans-serif;
  margin-top: var(--spacing-third);
  padding: 14px var(--spacing-medium);
  width: 100%;

  @media (--bp-desktop) {
    margin-top: var(--spacing-half);
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchFieldInput.vue